import React from 'react';
import { CourseWithGrades } from '../../../../types';
import { AssignmentsTable } from './assignments-table';

interface AssignmentsTabProps {
  selectedCourse: CourseWithGrades;
}

export const AssignmentsTab: React.FC<AssignmentsTabProps> = ({
  selectedCourse,
}) => {
  return (
    <div>
      <AssignmentsTable assignments={selectedCourse.assignments || []} />
    </div>
  );
};
